<template>
  <div class="font-readex  justify-space-between"  style="width: 100%">
    <v-app-bar
      dense
      height="80px"
      color="white"
      elevation="1"
      class="d-flex justify-space-between"
      style="width: 100% !important;"
    >
      <div class="font-weight-bold">
        <span v-if="$route.name === 'user.dashboard'">Dashboard</span>
        <span v-if="$route.name === 'user.orderHistory'">Historie objednávek</span>
        <span v-if="$route.name === 'user.orders'">Nová objednávka</span>
        <span v-if="$route.name === 'user.institution'">Správa strávníků</span>
      </div>
      <div class="d-flex float-right">
        <v-list-item
          two-line>
          <v-list-item-avatar>
            <v-icon>mdi-account</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
                <span class="font-weight-bold">
                  {{currentUser.firstName + ' ' + currentUser.lastName}}
                </span>
          </v-list-item-content>
        </v-list-item>
        <v-menu
          left
          offset-y
          bottom
          rounded
          min-width="200"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              class="align-self-center"
            >
              <v-icon small>fa-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item :to="{name: 'user.profile'}">
              <v-list-item-title class="font-readex" style="font-weight: 600; color: #bebebe">Upravit profil</v-list-item-title>
            </v-list-item>
            <v-list-item @click="logout">
              <v-list-item-title class="fontr-redex" style="color: #d60000; font-weight: 600">Odhlásit se</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>
    <v-alert
      v-for="(alert, index) in alerts"
      :key="index"
      :type="alert.type"
      v-show="alert.visible"
      style="margin-bottom: 0; border-radius: 0"
    >
      <v-row align="center">
        <v-col class="grow pa-0">
          {{alert.text}}
        </v-col>
        <v-col class="shrink pa-0">
          <v-btn
            small
            depressed
            :color="alert.type"
            @click="hide(alert)"
          >x</v-btn>
        </v-col>
      </v-row>
    </v-alert>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'AppBar',
  data () {
    return {
      alerts: [],
      currentRoute: null
    }
  },
  methods: {
    logout () {
      this.$http.post('/logout')
        .then(response => {
          this.$store.commit('user/clearUserData')
          this.$router.push({ name: 'login' })
        })
        .catch(err => {
          console.log(err)
        })
    },
    initialize () {
      this.$http.get(`/users/${this.currentUser.id}`)
        .then(response => {
          this.updateCredit(response.data.credit)
        })
      this.$http.get('/admin/alerts')
        .then(response => {
          this.alerts = this.keysToCamelCase(response.data)
            .filter(alert => alert.active)
            .map(alert => {
              alert.visible = true
              alert.type = alert.type === 0 ? 'info'
                : alert.type === 1 ? 'warning'
                  : 'error'
              return alert
            })
        })
        .catch(err => { console.log(err) })
    },
    hide (alert) {
      alert.visible = false
    },
    ...mapMutations({ updateCredit: 'user/updateCredit' })
  },
  computed: {
    ...mapGetters({ currentUser: 'user/currentUser' })
  },
  created () {
    this.initialize()
  }
}
</script>

<style scoped>
a{
  color: #ffffff;
}
  .cursor{
    cursor: pointer;
  }
  >>>.v-toolbar__content{
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
</style>
